var $ = require('../internals/export');
var bind = require('../internals/function-bind');

// `Function.prototype.bind` method
// https://tc39.github.io/ecma262/#sec-function.prototype.bind
$({ target: 'Function', proto: true }, {
  bind: bind
});



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.function.bind.js
// module id = 292
// module chunks = 3